import React, { useEffect, useState, useMemo } from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FiDownload } from 'react-icons/fi';
import { fetchBillsList, downloadBill } from './billParsingSlice';
import { LoadingState } from '../../utilities/constants';
import { parseUserInfo, formatDate } from '../../utilities/common';
import DataTable from '../../components/DataTable';
import Empty from '../../components/Empty';

const UploadedBillsTab = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orgId } = parseUserInfo(useSelector((state) => state.users.user));
  const { listStatus, bills = [] } = useSelector((state) => state.billParsing);
  const [currentPage] = useState(1);
  const [pageSize] = useState(20);

  useEffect(() => {
    dispatch(fetchBillsList({ orgId, page: currentPage, limit: pageSize }));
  }, [dispatch, orgId, currentPage, pageSize]);

  const tableColumns = useMemo(
    () => [
      {
        Header: t('File Name'),
        accessor: 'fileName'
      },
      {
        Header: t('Upload Status'),
        accessor: 'status'
      },
      {
        Header: t('Uploaded By'),
        accessor: 'uploadedBy'
      },
      {
        Header: t('Uploaded Date'),
        accessor: 'uploadedDate',
        Cell: ({ value }) => formatDate(value)
      },
      {
        Header: t('Actions'),
        Cell: ({ row }) => (
          <Button
            variant="link"
            size="sm"
            onClick={() => dispatch(downloadBill({ orgId, fileId: row.original.id }))}
            title={t('Download')}
          >
            <FiDownload />
          </Button>
        )
      }
    ],
    [t, dispatch, orgId]
  );

  if (listStatus === LoadingState.pending) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (listStatus === LoadingState.failed) {
    return <Empty title={t('Failed to load bills')} />;
  }

  if (bills.length === 0) {
    return <Empty title={t('No bills uploaded yet')} description={t('Click Upload & Parse tab to get started')} />;
  }

  return (
    <Card>
      <Card.Body>
        <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
          {t('Manage and review your previously uploaded utility bills')}
        </p>
        <DataTable columns={tableColumns} data={bills} defaultSort="uploadedDate" />
      </Card.Body>
    </Card>
  );
};

export default UploadedBillsTab;
